import { RefreshCw } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { AnnouncementBand, Button } from '@/design/components';

/** כשיש Service Worker חדש: פס "יש גרסה חדשה" עם כפתור רענון. */
export function UpdateBand() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });

  if (!needRefresh) return null;

  return (
    <AnnouncementBand icon={RefreshCw}>
      <span className="flex items-center justify-between gap-3">
        יש גרסה חדשה של האפליקציה.
        <Button variant="secondary" onClick={() => void updateServiceWorker(true)}>
          רענון
        </Button>
      </span>
    </AnnouncementBand>
  );
}
